<template>
  <div class="account-avatar-uploader" @click="handClick">
    <Img :src="value" class="w-full h-full" alt="avatar" />
    <div v-if="editable" class="avatar-hover">
      <CameraIcon class="icon-camera" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { showAvatarUploadModal } from '@rendora/common/features/upload-avatar/index';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store/user';
import CameraIcon from '@rendora/design/assets/camera.svg?component';
import { Img } from '@rendora/design/components/img/index';
const { t: $t } = getI18nService();

const props = withDefaults(
  defineProps<{
    value: string;
    editable?: boolean;
  }>(),
  {
    editable: true,
  },
);

const emits = defineEmits(['update']);
const userStore = useUserStore();

const handClick = () => {
  if (!props.editable) {
    return;
  }

  showAvatarUploadModal({
    title: $t('shang-chuan-tou-xiang'),
    currentAvatar: userStore.user?.logo_url || '',
  });
};
</script>

<style lang="scss">
.account-avatar-uploader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--x-back-3);

  .icon-camera {
    width: 24px;
    height: 24px;
    color: var(--x-white-1);
  }

  .avatar-hover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    .avatar-hover {
      opacity: 1;
    }
  }
}
</style>
